const ashbyProvider = {
  id: 'ashby',
  name: 'Ashby',
  description: 'Connect your Ashby ATS to sync jobs and candidates',
  connectionType: 'apiKey',
  assessmentSettingsUrl: 'https://app.ashbyhq.com/admin/integrations/marketplace/cavalry',
  assessmentInstructionsUrl: 'https://help.cavalryhr.com/en/articles/14770463-integrating-ashby-with-cavalry-hr-assessment',
  webhookInstructionsUrl: 'https://help.cavalryhr.com/en/articles/13189374-integrating-ashby-with-cavalry-hr',
  fields: [
    {
      name: 'apiKey',
      label: 'API Key',
      type: 'password',
      placeholder: 'Enter your Ashby API key',
      helpText: 'Required permissions: Jobs (read), Candidates (read/write), Interviews (read), API Keys (read/write)',
    }
  ],
};
// 8926e202136722250b248c543f4a02afb1f6244c7b8a73877323003985458d15

export default ashbyProvider;
